import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.replace("#", "")).get(
      "session_id"
    );
    const exchange = async () => {
      try {
        const res = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        navigate("/admin", { state: { user: res.data }, replace: true });
      } catch (err) {
        const denied = err?.response?.status === 403;
        navigate("/admin/login", {
          state: {
            error: denied
              ? "This Google account is not authorized to access the dashboard."
              : "Sign-in failed. Please try again.",
          },
          replace: true,
        });
      }
    };
    exchange();
  }, [navigate]);

  return (
    <div data-testid="auth-callback" className="min-h-screen bg-bone flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="animate-spin text-pine-500 mx-auto" size={32} />
        <p className="mt-4 text-sm text-sage">Signing you in securely…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
